/**
 * @typedef {Object} BookingCertificationViewModelType
 * @property {number} id - The certification type identifier
 * @property {string} name - The name of the certification
 */

/**
 * @class
 */
export default class BookingCertificationViewModel {
  /**
   * Create a new BookingCertificationViewModel.
   * @param {...BookingCertificationViewModelType} params
   */
  constructor(params) {
    this.id = params.id
    this.name = params.name
  }
}
